import React from "react";
import { newWindow } from "../../../utils/browser";
import Button from "../../Button";
import { USER_GUIDE_URL } from "../../../utils/user-guide";
export const PayRegistrationStep1 = ({ setIsCmsRegistrationForm }) => {
  return (
    <div className="pay-registration step1">
      <div className="pay-description" >
        <div className="pay-description-box">
          <div className="text">
            해당 기능은 <strong>위케이크 CMS</strong>사용자만 이용할 수 있습니다.<br /><br />
            <strong>위케이크 CMS</strong>로 간편하게 수금 관리하세요!<br />
            <strong>경리지원</strong>과 <strong>기장대리 서비스</strong>도<br />
            <span className="point"><strong>위케이크</strong></span>와 함께라면
            <strong className="point"> 더 빠르고 편리해</strong>집니다.
          </div>
          <div className="pay-description-button-wrap">
            <Button
              style={{
                width: '100%'
              }}
              onClick={(e) => setIsCmsRegistrationForm(true)}
            >
              위케이크 CMS 신청하기&nbsp;
            </Button>
            <div className="buttons">
              <Button
                color="text"
                onClick={(e) =>
                  newWindow(
                    "https://www.youtube.com/channel/UCbpaB_D8CVLE81QapgArgBg",
                    e
                  )
                }
              >
                wecake TV
              </Button>
              <Button
                color="text"
                onClick={(e) => newWindow(USER_GUIDE_URL, e)}
              >
                이용가이드
              </Button>
              <Button
                color="text"
                onClick={(e) => newWindow("https://yds.ai/", e)}
              >
                홈페이지
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
